module.exports = __webpack_public_path__ + "2e6ce2623bdecade804e6807cdb6eb60.jpg";